import { render } from "./redirectLandingPageComponent.vue?vue&type=template&id=41b788b8"
import script from "./redirectLandingPageComponent.vue?vue&type=script&lang=js"
export * from "./redirectLandingPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__